import { render, staticRenderFns } from "./showImg.vue?vue&type=template&id=dffcef86&scoped=true"
import script from "./showImg.vue?vue&type=script&lang=js"
export * from "./showImg.vue?vue&type=script&lang=js"
import style0 from "./showImg.vue?vue&type=style&index=0&id=dffcef86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffcef86",
  null
  
)

export default component.exports